/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `Concluído`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `Em andamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = () => `Registrado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `Visualizado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `Práticas recomendadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = () => `Certificado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = () => `Curso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = () => `Lição`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = () => `Saiba como expandir seus negócios com a Klaviyo. Comece a usar nossos cursos, certificações e guias para ajudá-lo a ter sucesso com a Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `Ir para a academia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `Não encontrado | Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = () => `/pt-br/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = () => `Ver todos os recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = () => `Acelere com a Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = () => `Aprenda as estratégias e as melhores práticas de que você precisa para maximizar a receita e atingir suas metas comerciais.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = () => `Decida como você quer aprender`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = () => `/pt-br/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = () => `Veja todos os guias de introdução`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = () => `<p>Siga os guias passo a passo para começar a trabalhar com novos canais, recursos e produtos.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = () => `Introduções`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = () => `/pt-br/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = () => `Veja todas as práticas recomendadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = () => `<p>Expanda seus negócios e otimize seu marketing com nossas principais estratégias.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = () => `Práticas recomendadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = () => `/pt-br/search?select=Quick+guide|Under+10+minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = () => `Ver todos os guias rápidos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = () => `<p>Encontre respostas em 10 minutos ou menos com guias convenientes de uma página.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = () => `Guias rápidos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = () => `/pt-br/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = () => `Ver todos os treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = () => `<p>Participe de sessões ao vivo com especialistas da Klaviyo e tire suas dúvidas em tempo real.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = () => `/pt-br/search?select=Course`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = () => `Ver todos os cursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = () => `<p>Saiba como aplicar efetivamente a estratégia de marketing em sua empresa com conteúdo de aprendizado sob demanda e exemplos práticos.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = () => `Cursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = () => `/pt-br/search?select=Certificate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = () => `Ver todos os certificados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = () => `<p>Aprofunde-se em um tópico por meio de uma série de cursos. Teste seus conhecimentos com um exame final para obter um certificado de conclusão.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = () => `Certificados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = () => `Escolha entre diversas opções que se encaixam à sua agenda e estilo de aprendizado.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = () => `/pt-br/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = () => `Ver todos os treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = () => `Aprenda com nossa equipe de especialistas em tempo real.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = () => `Inscreva-se para uma sessão de treinamento ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = () => `Detalhamento da entregabilidade de e-mails com estratégias para avaliar e melhorar seu desempenho.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = () => `https://www.bigmarker.com/klaviyo-customer-education/strategy-session-understand-email-deliverability`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = () => `Entenda a entregabilidade de e-mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = () => `Conheça princípios de design para ajudar a impulsionar o tráfego e a conversão.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-Design-emails-that-convert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = () => `Crie e-mails que convertem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = () => `Entenda o valor do SMS como canal e como integrá-lo ao seu fluxo de trabalho.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-SMS-marketing-strategy-North-America`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = () => `Estratégia de marketing por SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = () => `Tire dúvidas sobre estratégias em tempo real com os especialistas da Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Office-hours-Getting-started-with-Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = () => `Horário de expediente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = () => `/pt-br/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = () => `Veja as práticas recomendadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = () => `Conheça as principais estratégias de marketing para ajudá-lo a conquistar clientes, automatizar o engajamento e aumentar as vendas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = () => `Guias de práticas recomendadas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = () => `https://www.youtube.com/channel/UCLLurTBYufj95_5zTnJISnA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = () => `Visite a biblioteca do YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = () => `Assista a tutoriais em vídeo para obter dicas rápidas e insights de especialistas para ajudá-lo a expandir seus negócios com a Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = () => `Klaviyo no YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = () => `/pt-br/courses/anatomy-of-a-flow-welcome-series/1881997`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = () => `Comece a aprender`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = () => `Crie uma série de boas-vindas personalizada e conheça as práticas recomendadas para criar conexões fortes com os contatos inscritos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = () => `Anatomia de um fluxo: série de boas-vindas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = () => `Novo e digno de nota`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = () => `Confira os cursos, guias e treinamentos mais recentes de nossa equipe de especialistas do mundo todo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = () => `/pt-br/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = () => `Ver todos os recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = () => `/pt-br/collections/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = () => `/pt-br/courses/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = () => `Recursos recomendados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = () => `/pt-br/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = () => `Veja todos os guias de introdução`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = () => `Saiba como integrar seu ecossistema de comércio eletrônico, coletar contatos inscritos e começar a enviar mensagens com a plataforma Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = () => `/pt-br/courses/getting-started-with-klaviyo/1459179`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = () => `Curso, Introdução`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = () => `Introdução aos formulários de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = () => `Saiba o que são segmentos, como criá-los e como usar segmentos para enviar campanhas de marketing mais direcionadas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = () => `/pt-br/courses/getting-started-with-sms/1411601`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = () => `Curso, Introdução`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = () => `Introdução aos segmentos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = () => `Não sabe como usar as campanhas da Klaviyo? Suba de nível com os segredos internos de 143 mil marcas em nosso curso Introdução às campanhas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = () => `/pt-br/courses/getting-started-with-klaviyo-cdp/1759043`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = () => `Introduções`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = () => `Introdução às campanhas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = () => `Aprenda os fundamentos dos fluxos, crie seu primeiro fluxo automatizado na plataforma Klaviyo e siga as práticas recomendadas para aumentar a receita.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = () => `/pt-br/courses/develop-a-klaviyo-reviews-strategy/1630005`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = () => `Introdução, Curso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = () => `Introdução aos fluxos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = () => `Comece com o básico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = () => `O que nossos clientes estão dizendo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = () => `/pt-br/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = () => `Inscreva-se para um treinamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_size = () => `large`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = () => `Os exemplos. É sempre útil ver como os especialistas fazem. Aprendi a navegar e a trabalhar na plataforma Klaviyo graças a esses treinamentos <3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = () => `/pt-br/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = () => `Inscreva-se para um treinamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_size = () => `small`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = () => `Os exemplos do mundo real, as instruções passo a passo e as melhores práticas foram INCRÍVEIS. Considero os webinários da Klaviyo os mais interessantes de que participo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = () => `/pt-br/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = () => `Inscreva-se para um treinamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_size = () => `small`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = () => `Otimista, direto e conciso. Sem ilusões. Meu tempo é valioso e foi respeitado. Ótima demonstração!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = () => `/pt-br/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = () => `Inscreva-se para um treinamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_size = () => `large`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = () => `Eu adorei os palestrantes. Todos tinham conhecimento e eram capazes de fornecer conteúdo de uma forma envolvente. Gostei das ideias e das reflexões necessárias ao planejamento dessa sessão.  Obrigado, Klaviyo! No final da sessão, minha cabeça estava cheia de ideias para meus clientes.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `Dispensar mensagem`


export { atoms_singleLineForm_error } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_primaryButton } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `Ir para o conteúdo principal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `Slide atual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `Ir para o slide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Início`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Pesquisar tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Mapa do site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Nota`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Requisitos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Aviso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Recursos em destaque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Solicitação de acesso à conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Artigo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Pesquise nosso banco de conhecimento e encontre respostas para as perguntas mais frequentes. Confira artigos, fóruns, treinamentos ao vivo e gravados e muito mais para aproveitar a Klaviyo ao máximo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Seção`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Saiba mais sobre a Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `O que podemos ajudar você a encontrar hoje?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Ir para a central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Não encontrado | Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Principais artigos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Recursos em destaque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Confira manuais, treinamentos e recursos educacionais para expandir seus negócios com a Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Pesquisar por tópico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Pesquisar por tópico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Nenhum resultado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Tente fazer uma pesquisa diferente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Nenhum resultado para`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Desenvolvedores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Ver tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `pt-BR`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `pt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `America/Sao_Paulo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates = () => `Próximas datas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Estimado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `min de leitura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Atualizado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `Saiba como entrar em contato com o suporte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Permitir que a Klaviyo entre em contato para discutir meu feedback.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Descreva o que você está tentando fazer, aprender ou resolver.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Seu endereço de e-mail deve incluir um único "@" seguido de um domínio válido (nome@exemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Como podemos melhorar esse artigo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Descreva o que você gostou ou como o artigo pode melhorar.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Precisa de mais detalhes ou explicações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Não se relaciona com minha busca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Agradecemos a informação! Fale mais sobre o problema.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Pode fornecer mais detalhes?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Enviar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Só entraremos em contato para discutir o feedback sobre esse artigo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `nome@exemplo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Pouco claro, confuso ou difícil de entender`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Não corresponde à experiência do produto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Use esse formulário somente para dar feedback sobre os artigos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `Esse artigo foi útil?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `Não`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Seu feedback foi enviado. Obrigado.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Estamos felizes em poder ajudar!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Sim`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `Foto de perfil do autor`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Imagem da Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `min de leitura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `Leia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = () => `Dias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = () => `h`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = () => `min`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = () => `s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `Tópico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = () => `vagas abertas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `Salvar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `Salvo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `Próximo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `Anterior`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `abre em uma nova aba`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Pesquise por tópico ou palavra-chave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `artigo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `artigos`


/**
 * @param {{ days: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d = (params) => `${params.days}d`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h = (params) => `${params.hours}h`


/**
 * @param {{ minutes: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m = (params) => `${params.minutes}m`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now = () => `Agora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day = () => `dia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days = () => `dias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour = () => `hora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours = () => `horas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute = () => `minuto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes = () => `minutos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn = () => `Este evento começa em`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow = () => `Este evento começa agora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Sair da Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Ver minhas credenciais no Accredible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `Ver minhas credenciais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Meus recursos da Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Entrar na Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Fale conosco`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Entrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Suporte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `Voltar ao topo`


export { organisms_articleTableContents_overview } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `Índice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = () => `BFCM 2024`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = () => `Faça cada dia valer a pena`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = () => `Eu sou`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = () => `Eu quero`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = () => `este BFCM`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `Imagem em destaque`


export { organisms_blogCards_viewAll } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `Exibir categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `Seu recurso de marketing próprio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `A abordagem Klaviyo`


export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `Dias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `Horas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `Minutos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `Segundos`


export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Integre sua loja online e comece a enviar mensagens com a Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Introdução à Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Estabeleça a base para enviar mensagens SMS.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/pt-br/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Como configurar SMS na Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Crie e envie sua primeira campanha de e-mail.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/pt-br/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `Como criar e enviar uma campanha de e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Use formulários para interagir com assinantes e coletar informações.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/pt-br/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Introdução aos formulários de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Crie fluxos completos em grande escala usando linguagem natural.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/pt-br/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `Como usar IA para criar um fluxo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Reúna feedback dos clientes e gere mais conversões.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/pt-br/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Introdução às avaliações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Carregar mais`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. Todos os direitos reservados.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Suas configurações de privacidade`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Solicitação de acesso à conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Solicitação de acesso à conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Seu endereço de e-mail deve incluir um único "@" seguido de um domínio válido (nome@exemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Digite um e-mail válido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `Obrigatório – se não for relevante, responda "NA".`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `O site da sua empresa precisa incluir um domínio válido (https://exemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Insira o nome da sua conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Adicionar destinatário`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Destinatários adicionais (opcional)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Insira um endereço de e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `E-mail da conta Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Insira um endereço de e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Com o que você precisa de ajuda?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Descreva o problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `Autenticação multifator`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Conta desativada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Esqueci a senha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Dúvida sobre a fatura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `Suporte à autenticação multifator`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Atualize o proprietário da conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Como configurar um novo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `Como configurar um novo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Selecione um problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `Nome da última campanha ou fluxo criado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `Digite o nome da campanha ou do fluxo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `Crie uma nova página no site de sua empresa com o título "Klaviyo Test" e adicione o URL aqui`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `Insira o URL do site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `Por motivos de segurança, responda às perguntas a seguir para verificar sua identidade. Se não tiver certeza, digite "NA".`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `Use este formulário somente para relatar problemas de autenticação multifator, como perda de acesso ao dispositivo de autenticação. Esse formulário requer informações pessoais para autenticação manual. Para problemas não relacionados à autenticação multifator, selecione outra opção.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `Data estimada do último login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `Insira a data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `Endereço registrado de correspondência da organização`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `Insira o endereço`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `Nomes ou endereços de e-mail de outros usuários da sua conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `Insira nomes ou endereços de e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `Nome ou e-mail de 5 perfis da sua conta com pelo menos 1 mês de existência`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `Insira nomes ou endereços de e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `Selecione um motivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `Perdeu acesso ao aplicativo autenticador`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `Novo dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `Novo número de telefone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `Não recebeu o código por SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `Qual foi o valor da sua última fatura da Klaviyo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `Insira o valor da fatura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Insira seu nome completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Enviar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `URL do site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Insira o URL do site`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Está com problemas para acessar sua conta?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Envie suas informações para nossa equipe de suporte e entraremos em contato em breve.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/hc/pt-br`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Ir para a página inicial`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Sua solicitação foi enviada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Nossa equipe de suporte entrará em contato o mais rápido possível. A resposta será enviada para o e-mail informado.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Todos os campos são obrigatórios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Receba uma apresentação gratuita para descobrir tudo o que podemos oferecer: plataforma de dados da Klaviyo, insights baseados em IA, SMS, e-mail personalizados e muito mais! `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Solicite uma demonstração`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Enviando…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Fale sobre sua marca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Fale sobre sua marca`


export { organisms_forms_demo_recaptcha_privacy } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Explore todos os recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Veja os recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Tudo pronto!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `Sua solicitação não foi bem-sucedida. Tente novamente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `Sua solicitação não foi bem-sucedida devido a um erro de rede. Tente novamente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `Você se inscreveu muitas vezes em um curto período. Aproveite suas contas existentes ou entre em contato com o suporte ao cliente para receber mais ajuda.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `O reCAPTCHA é obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `Sou uma agência e assino por meu cliente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `Por favor, digite o nome de sua empresa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `Nome da empresa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `Digite o nome de sua empresa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `Número de contatos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500 mil - 1 milhão`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1 mil - 3 mil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100 mil - 500 mil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `Mais de 1 milhão`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3 mil - 25 mil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25 mil - 100 mil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0 - 1 mil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `Selecione o número de contatos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `Certifique-se de que o site de sua empresa inclua um domínio válido (https://exemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `Site da empresa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `Gostaria de uma conversa/explicação ao vivo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `Selecione um produto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `Plataforma de comércio eletrônico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce (Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Stores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `Tenho uma loja personalizada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `Não se aplica à minha empresa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `Plataforma de comércio eletrônico não listada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `Selecione sua plataforma`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `Certifique-se de que seu endereço de e-mail inclua um único @, seguido de um domínio válido (nome@exemplo.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `nome@exemplo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `Selecione sua receita anual estimada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `Receita anual estimada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `US$ 5 milhões - US$ 20 milhões`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `Mais de US$ 400 milhões`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `US$ 20 milhões - US$ 400 milhões`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `Menos de US$ 5 milhões`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `Selecione a receita anual estimada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Selecione como você usará a plataforma Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Como você usará a plataforma Klaviyo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `Para o negócio do meu cliente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `Para meu próprio negócio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Selecione como você usará a plataforma Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `Selecione seu tipo de negócio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `Tipo de negócio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `Outros produtos e serviços não varejistas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `Bens de varejo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `Serviços de varejo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `Selecione o tipo de negócio`


export { organisms_forms_fields_firstname_errors_required } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `Insira seu nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `Nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `Nome completo`


export { organisms_forms_fields_general_errors_required } from "./en-US.js"

export { organisms_forms_fields_lastname_errors_required } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `Inscreva-se para receber as comunicações de marketing da Klaviyo, incluindo boletins informativos, postagens em blogs, notícias sobre produtos, webinários e publicidade direcionada. Você pode cancelar a inscrição para receber marketing por e-mail por meio do link para cancelamento de inscrição nos e-mails.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `Sua senha é muito comum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `Certifique-se de que sua senha não tenha mais de 128 caracteres.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `Certifique-se de que sua senha inclua pelo menos 8 caracteres.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `Senha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `Digite sua senha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `Certifique-se de que seu número de telefone inclua seu código de área ou código do país`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `O número deve ter 15 caracteres ou menos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `Obrigatório`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `Número de telefone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `Digite seu número de telefone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `Selecione um produto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `Em quais produtos você tem interesse? Selecione todas as opções aplicáveis.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `Notificações Push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `Avaliações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `Selecione os produtos`


export { organisms_forms_fields_website_errors_url } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `Ao enviar este formulário, você concorda com o`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `e`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `Política de privacidade`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `Termos de serviço`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `Envie sua primeira campanha em minutos – e coloque seu marketing no piloto automático – com mensagens de e-mail e SMS direcionadas que convertem em vendas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `Criar conta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `Enviando…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `Comece hoje`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Ir para`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Todas as localizações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Pesquisar empregos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Todos os sistemas operacionais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Serviço de sistema degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Falha grave do sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Pequena falha de serviço`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Pequena falha do sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Falha parcial do sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Serviço parcialmente degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Sistema parcialmente degradado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Serviço em manutenção`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Fechar modal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Visite a Klaviyo Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Conecte-se com colegas, parceiros e especialistas da Klaviyo para ter ideias, compartilhar insights e tirar dúvidas.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Registre-se agora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Treinamentos ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `Calendário`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Participe de uma sessão ao vivo com especialistas da Klaviyo para conhecer práticas recomendadas, saber como configurar os principais recursos e muito mais.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Entrar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Suporte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `Suporte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Acesse o suporte na sua conta.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Chat/assistência virtual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `A disponibilidade varia conforme o local e o tipo de plano`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Suporte por e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(teste gratuito e contas pagas)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Disponível 24 horas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `Ver todas as categorias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `Ver menos categorias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Solicite uma demonstração`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Ir para a página inicial da Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Ir para o "Impulsionador digital Klaviyo"`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Logotipo da Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Novidades sobre os produtos Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Ler`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Ver tudo`


export { organisms_post_filter_ResourceCategory } from "./en-US.js"

export { organisms_post_filter_ResourceCollection } from "./en-US.js"

export { organisms_post_filter_ResourceStage } from "./en-US.js"

export { organisms_post_filter_ResourceTopic } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_post_filter_search } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `Inclui taxas de operadora estimadas em`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `O preço por SMS/MMS pode variar de acordo com o tamanho da mensagem.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `crédito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `creditos`


export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `Áustria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `Austrália`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `Bélgica`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `Canadá`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `Suíça`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `Alemanha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `Dinamarca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `Espanha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `Finlândia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `França`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `Reino Unido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `Irlanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `Itália`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `Países Baixos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `Noruega`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `Nova Zelândia`


export { organisms_pricing_calculator_locales_PT } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `Suécia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `Estados Unidos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `número máximo de envios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_not_available } from "./en-US.js"

export { organisms_pricing_calculator_not_available } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `Preço por`


export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `Enviar para`


export { organisms_pricing_calculator_service_type } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `Limite de perfis ativos excedido`


export { organisms_pricing_contactSales } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `Perfis ativos`


export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `Gestão de sucesso do cliente por US$ 1.500/mês`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `Suporte por e-mail e chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `Estime seu preço`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `Créditos mensais gratuitos de SMS/MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `Suporte por e-mail nos primeiros 60 dias`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `Solicite uma demonstração`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `Quantos perfis ativos você tem?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `Inclui as taxas aplicáveis da operadora de SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `Solicite uma demonstração`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `Vamos conversar!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `Se você tiver mais de 250.000 perfis ativos, entre em contato com nossa equipe de vendas para encontrar o plano ideal para você.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `Notificação por push para mobile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `Você pode usar seus créditos para SMS, MMS ou ambos.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `As mensagens SMS e MMS custam um número diferente de créditos, com base na localização do destinatário.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `Créditos de SMS/MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `mês`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `envios de e-mail mensais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `créditos de SMS/MMS mensais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `Embarque a partir de US$ 450/mês`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(abre um modal)`


export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `Alcance clientes por e-mail e SMS e faça seu marketing ir ainda mais longe.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `E-mail e SMS`


export { organisms_pricing_plans_emailPlusSms_creditsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `Dê o próximo passo em seu marketing por e-mail com uma solução simples que personaliza em escala.`


export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `E-mail`


export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `Perfeito para começar e experimentar a plataforma de clientes da Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `Grátis`


export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_getStarted_text } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_headline } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_price_subText } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_subText } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subText } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_reviews_slider_subText } from "./en-US.js"

export { organisms_pricing_plans_reviews_subText } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS = 4 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `Austrália`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS = 5 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS = 3 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `Canadá`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS = 7 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `França`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS = 12 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `Alemanha`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS = 9 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `Irlanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS = 7 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `Itália`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS = 10 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `Nova Zelândia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS = 12 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `Países Baixos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS = 3 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `Portogallo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS = 5 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `Reino Unido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS = 3 créditos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS = 1 crédito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `EUA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `Cadastre-se`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `Começando em`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `Suporte para ampliar seus negócios`


export { organisms_scroll_social_proof_button } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_3 } from "./en-US.js"

export { organisms_scroll_social_proof_href } from "./en-US.js"

export { organisms_scroll_social_proof_quote_end } from "./en-US.js"

export { organisms_scroll_social_proof_quote_start } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_button } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_href } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_subhead } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_benchmarks } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_customer_hub } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_email_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_integrations } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_klaviyo_ai } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_mobile_push } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_profiles } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reporting } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reviews } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_segments } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_sms_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_27Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_43Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_createWithAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_describeFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_generateDraft } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_smsABTest } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_champions } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_championsFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionOverview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_eightPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_excellent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersAdded } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersDropped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthOne } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_threePercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_totalMembers } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_accessories } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_activity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToBag } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToCart } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_arrivingToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_chat } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_clothing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_color } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_coral } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_findAStore } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_forYou } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_help } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_l } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_maroon } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliams } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_new } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_orders } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_phoneNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_profile } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_saySomething } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_seanH } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_selectSize } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_shoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sky } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_welcomeMia } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xs } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xxl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_Enjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_customerActivity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_discountCode } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_email } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_inbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_name } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderDelivered } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderShipped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_shopNow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_4 } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `Ver tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `Reproduzir vídeo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Limpar tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Recolher tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Todas as atualizações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Buscar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Conta e cobranças`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_advanced_kdp = () => `Advanced KDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Análises`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Público`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Benefícios`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Campanhas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Em breve`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Entregabilidade e conformidade`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Fluxos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Disponibilidade geral`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Liberação gradual`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integrações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Disponibilidade limitada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_marketing_analytics = () => `Klaviyo Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Notificações push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Tipo de lançamento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Avaliações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Formulários de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Tópico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Assista ao resumo trimestral`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `Início`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `Pesquisar empregos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `Aplicar filtro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `Limpar filtro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `País`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `Palavras-chave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `Pesquisar empregos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `Filtrar empregos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `Localização`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `Desculpe, não foram encontradas vagas que correspondam aos seus critérios.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `Tente critérios de pesquisa diferentes ou clique para <a href="#" onclick="window.location.href='/careers/search-jobs'">ver todas as nossas vagas abertas</a>.`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `Mostrando <strong>${params.start}</strong> - <strong>${params.end}</strong> de <strong>${params.total}</strong> empregos correspondentes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `Equipe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `Pesquisar empregos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `Buscar empregos | Klaviyo Careers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `Visto recentemente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `Empregos salvos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Não é o que você estava procurando? Acesse a <a href="/email-marketing">página de e-mail</a>, a <a href="/sms-marketing">página de SMS</a> ou a <a href="/">página inicial</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Ir para a página inicial`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Página não encontrada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `É pronunciado`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `horas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minutos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `hora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minuto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Pergunta respondida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Todos os recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Limpar tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Recolher tudo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Desenvolvedores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Central de ajuda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Recursos de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Recurso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Pesquisar todos os recursos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Verifique a ortografia ou faça uma pesquisa diferente.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Não encontramos nenhum resultado para "${params.query}".`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Pesquise por tópico ou palavra-chave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_duration = () => `Duração`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_language = () => `Idioma`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_location = () => `Localização`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_type = () => `Tipo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_english = () => `Inglês`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_french = () => `Francês`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_spanish = () => `Espanhol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_apac = () => `Ásia/Austrália`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_emea = () => `Europa/África`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_nam = () => `América do Norte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_type_liveTraining = () => `Treinamento ao vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `Categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `Tipo de post`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `BFCM`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `Estudo de caso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `Comparações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `Demos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `Setores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `Recurso de marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `Mídia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `Páginas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `Parceiros`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `Podcast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `Atualização de produto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `Produtos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `Lançamento trimestral`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `Soluções`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `Sucesso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `Ferramentas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Conta e cobranças`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Análises`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Público`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Campanhas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Entregabilidade e conformidade`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Fluxos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integrações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Notificações push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Avaliações`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Formulários de registro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Principais resultados de pesquisa`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Mostrando ${params.y} de ${params.x}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Pesquisas sugeridas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Introdução à Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Introdução ao SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Introdução à CDP da Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Introdução aos formulários`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Crie um calendário de conteúdo na Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Ver`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Ver todos os ${params.index} resultados`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Ver mais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `Categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Mapa do site da Klaviyo`


export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `abre em uma nova aba`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `Postagens deste autor`


/**
 * @param {{ category_name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = (params) => `artigos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `Em destaque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `Cliente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `Setor`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `Plataforma`


export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

export { app_marketplace_details_built_by } from "./en-US.js"

export { app_marketplace_details_carousel_close } from "./en-US.js"

export { app_marketplace_details_carousel_image_alt } from "./en-US.js"

export { app_marketplace_details_carousel_next_image } from "./en-US.js"

export { app_marketplace_details_carousel_previous_image } from "./en-US.js"

export { app_marketplace_details_case_study } from "./en-US.js"

export { app_marketplace_details_category } from "./en-US.js"

export { app_marketplace_details_cover_image } from "./en-US.js"

export { app_marketplace_details_developer } from "./en-US.js"

export { app_marketplace_details_features } from "./en-US.js"

export { app_marketplace_details_guide } from "./en-US.js"

export { app_marketplace_details_install } from "./en-US.js"

export { app_marketplace_details_install_installs } from "./en-US.js"

export { app_marketplace_details_languages } from "./en-US.js"

export { app_marketplace_details_marketing_video } from "./en-US.js"

export { app_marketplace_details_overview } from "./en-US.js"

export { app_marketplace_details_pricing } from "./en-US.js"

export { app_marketplace_details_pricing_free } from "./en-US.js"

export { app_marketplace_details_pricing_learn_more } from "./en-US.js"

export { app_marketplace_details_similar_apps } from "./en-US.js"

export { app_marketplace_details_support } from "./en-US.js"

export { app_marketplace_details_support_help } from "./en-US.js"

export { app_marketplace_details_support_privacy } from "./en-US.js"

export { app_marketplace_details_support_website } from "./en-US.js"

export { app_marketplace_details_user_guide } from "./en-US.js"

export { app_marketplace_gallery_thumbnail } from "./en-US.js"

export { app_marketplace_gallery_thumbnail_alt } from "./en-US.js"

export { app_marketplace_install_alert_learn_more } from "./en-US.js"

export { app_marketplace_install_button } from "./en-US.js"

export { app_marketplace_install_status_invalid_permissions } from "./en-US.js"

export { app_marketplace_install_status_unhealthy } from "./en-US.js"

export { app_marketplace_install_status_uninstallable } from "./en-US.js"

export { app_marketplace_installed_button } from "./en-US.js"

export { app_marketplace_manage_button } from "./en-US.js"

export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_preview_banner } from "./en-US.js"

export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

export { molecules_blogCard_related_content } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_profile_href } from "./en-US.js"

export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

export { organisms_moreCards_card1_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card2_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

export { academy_courseStatus_registed } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BR = () => `Portogallo`
